import '../../styles/system.css';

export default function OfflineError() {
  const whatsappText = encodeURIComponent(
    'Hello MF_NAILEDIT, I could not complete my request because the website showed an error. Please help me check the booking or payment status before I try again.'
  );

  function retry() {
    window.location.reload();
  }

  return (
    <main className="system-page">
      <section className="system-card system-card-warning" aria-labelledby="offline-title">
        <span className="system-pill system-pill-warning">LIMITED ACCESS</span>
        <h1 id="offline-title">Something went wrong</h1>
        <p className="system-copy">
          The system could not complete the request. No booking or payment should be assumed until the user receives a verified status.
        </p>

        <div className="system-note">
          <span>DEVELOPER RULE</span>
          <p>
            Show this state instead of a broken screen. Preserve clear recovery actions and never expose private booking, payment or customer data while unauthorised.
          </p>
        </div>

        <button className="button button-primary system-action" type="button" onClick={retry}>
          Try again
        </button>
        <a
          className="button button-secondary system-action"
          href={`https://wa.me/2347069460987?text=${whatsappText}`}
          target="_blank"
          rel="noreferrer"
        >
          Open WhatsApp
        </a>
      </section>
    </main>
  );
}
